import { useState, useEffect, forwardRef, useImperativeHandle } from "react";
import {
  CustomContainer,
  connect,
  Cookie,
  useRouter,
} from "../../atoms/DependencyHelper";
import PersonalDetails from "../../molecules/checkoutCreditCheck/personalDetails/PersonalDetails";
import EmploymentDetails from "../../molecules/checkoutCreditCheck/employmentDetails/EmploymentDetails";
import HomeDetails from "../../molecules/checkoutCreditCheck/homeDetails/HomeDetails";
import ConsentResultDetails from "../../molecules/checkoutCreditCheck/consentResultDetails/ConsentResultDetails";
import DebitDetails from "../../molecules/checkoutCreditCheck/debitDetails/DebitDetails";
import DeliveryDetails from "../../molecules/checkoutCreditCheck/deliveryDetails/DeliveryDetails";
import ContactDetails from "../../molecules/checkoutCreditCheck/contactDetails/ContactDetails";
import OutcomeInformation from "../../atoms/newLineForms/outcomeInformation/OutcomeInformation";
import {
  imagePrefix,
  urlPrefix,
  setCookieConsentWrapper,
  getCookieValue,
  showSpinner,
  hideSpinner,
  getOrderCreated,
} from "../../../utils/helperServices";
import labels from "../../../config/labels";
import config from "../../../config/index";
import Image from "../../atoms/image/image";
import styles from "./CheckoutCreditCheck.module.scss";
import { journeyType } from "../../../context/checkout-journey-context";
import {
  setPaymentMethod,
  setShippingMethodsOnCartService,
} from "../../../services/checkoutService";
import * as Analytics from "../../../services/analyticsUtag";
import { productOrderReq } from "../../../data/mockRenderComponent";
import axios from "axios";
import DeliveryTitle from "../../atoms/deliveryTitle/DeliveryTitle";
import { setPostCheckoutCurrentStep } from "../../../Redux/actions/checkoutAction";
import ajaxService from "../../../utils/ajaxServices";

const CheckoutCreditCheck = forwardRef(
  (
    {
      userLoggedIn,
      profileData,
      customerStatus,
      addressTypes,
      statesTypes,
      countryCode,
      countryName,
      setShowSnackBar,
      setPageErr,
      navigate,
      continueDisable,
      creditCheckDetails,
      authDetailsData,
      setDisableBackButton,
      handleHeading,
      carrierCode,
      methodCode,
      dealCategoryId,
      cartDetails,
      currentJourneyType,
      creditVettingDetails,
      paymentMethodCode,
      multicartFlag,
      numberTransferEnabled,
      setShowOnceOff,
      setPostCheckoutCurrentStep,
    },
    ref
  ) => {
    const showPersonalDetails = creditVettingDetails ? false : true;
    const [showContactDetails, setShowContactDetails] = useState(
      creditVettingDetails
        ? false
        : creditCheckDetails.personalDetails ||
          creditCheckDetails.contactDetails
        ? true
        : currentJourneyType == journeyType.addLine
        ? true
        : false
    );
    const [showEmploymentDetails, setShowEmploymentDetails] = useState(
      creditVettingDetails
        ? false
        : creditCheckDetails.contactDetails ||
          creditCheckDetails.employmentDetails
        ? true
        : false
    );
    const [showHomeDetails, setShowHomeDetails] = useState(
      creditVettingDetails
        ? false
        : creditCheckDetails.employmentDetails || creditCheckDetails.homeDetails
        ? true
        : false
    );
    const [showDebitDetails, setShowDebitDetails] = useState(
      creditVettingDetails
        ? false
        : creditCheckDetails.homeDetails || creditCheckDetails.debitDetails
        ? true
        : false
    );
    const [showDeliveryDetails, setShowDeliveryDetails] = useState(
      creditVettingDetails
        ? false
        : creditCheckDetails.debitDetails || creditCheckDetails.deliveryDetails
        ? true
        : false
    );
    const [showConsentDetails, setConsentDetails] = useState(
      creditCheckDetails.deliveryDetails ? true : false
    );
    const [showDocsData, setShowDocsData] = useState(false);
    const [showOfflineData, setShowOfflineData] = useState(false);
    const [getCreditOutcome, setCreditOutcome] = useState({
      visible: false,
      title: "Your credit status has been approved!",
      desc: "You can now continue with your application.",
      screenType: "approved",
      isdisableBackButton: false,
      isHidePageDesription: false,
    });

    const [formEditState, setEditFormState] = useState({
      personalDetails: false,
      contactDetails: false,
      employmentDetails: false,
      debitDetails: false,
      homeDetails: false,
      deliveryDetails: false,
    });
    const [doCreditCheckDisable, setDoCreditCheckDisable] = useState(false);
    const [orderSplitMessage, setOrderSplitMessage] = useState("");
    const [submitDocMessage, setSubmitDocMessage] = useState("");
    const multiCartText = multicartFlag ? "_multicart" : "";

    useEffect(() => {
      setDoCreditCheckDisable(
        Object.keys(formEditState).every((k) => !formEditState[k])
      );
    }, [formEditState]);

    useImperativeHandle(ref, () => ({
      submit: async () => {
        Analytics.link({
          link_type: "o",
          link_name: `checkout: credit check: ${customerStatus}: continue`,
        });
        continueDisable(true);

        navigate(
          numberTransferEnabled
            ? "numberTransfer"
            : "delivery"
        );
      },
      back: () => {
        if (authDetailsData?.idType == "PASSPORT") {
          Analytics.link({
            link_type: "o",
            link_name: `checkout: credit check: ${customerStatus}: back to lets get started`,
          });
        }
      },
    }));

    useEffect(() => {
      if (
        getCreditOutcome.screenType ===
          `${labels.creditVetting.lbl_resultcode_pended + multiCartText}` ||
        getCreditOutcome.screenType ===
          `${labels.creditVetting.lbl_resultcode_pending + multiCartText}` ||
        getCreditOutcome.screenType ===
          `${labels.creditVetting.lbl_resultcode_referred + multiCartText}` ||
        getCreditOutcome.screenType ===
          `${labels.creditVetting.lbl_resultcode_offline + multiCartText}` ||
        getCreditOutcome.screenType
          ?.toUpperCase()
          .includes(labels.creditVetting.lbl_unprocessed)
      ) {
        //If browser back button is clicked, go back to multi cart page
        window.onpopstate = () => {
          showSpinner();       
          router.push(`${urlPrefix}/cart`).then(() => {
            setPostCheckoutCurrentStep(null);
            hideSpinner();
          });
        };
      }
    });

    useEffect(() => {
      if (customerStatus) {
        Analytics.view({
          page_event: "view",
          page_name: `checkout: credit check: ${customerStatus}`,
          page_channel: "checkout",
          page_master_tab: "personal",
          multicart_flag: multicartFlag ? true : false,
          ...Analytics.getProfileData(userLoggedIn, profileData, authDetailsData),
        });
      }
    }, [customerStatus]);

    const updateShowDebitDetails = function (arg) {
      if (currentJourneyType == journeyType.addLine) {
        setShowDebitDetails(true);
        setShowDeliveryDetails(true);
      } else {
        let obj =
          creditCheckDetails.homeDetails || creditCheckDetails.debitDetails
            ? true
            : false;
        setShowDebitDetails(obj);
      }
    };

    // changes for pended, referred, pending
    const router = useRouter();
    const cartId = getCookieValue("cart_id");
    const authToken = getCookieValue("auth_token");
    const vodAuthToken = getCookieValue("vod-web-auth-token");

    const totalZero =
      parseFloat(cartDetails?.shippingFeeCalculate?.shipping_fee) +
        parseFloat(cartDetails?.prices?.grand_total?.value) ==
      parseFloat(0)
        ? "true"
        : "false";

    const orderRouter = () => {
      let headers = {};
      let postOrder = JSON.parse(
        JSON.stringify(productOrderReq).replace(/\:null/gi, ':""')
      ); //replace null with "" for all attributes
      postOrder.productOrder[0].externalId = cartId;
      postOrder.productOrder[0].journeyType = currentJourneyType;
      postOrder.productOrder[0].contact.identificationID =
        authDetailsData?.idNumber;
      postOrder.productOrder[0].contact.identificationType =
        authDetailsData?.idType;
      postOrder.productOrder[0]["removeStandalone"] = false;

      if (vodAuthToken) {
        headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-auth-jwt": `Bearer ${vodAuthToken}`,
          "x-magento-token": `Bearer ${authToken}`,
        };
      } else {
        headers = {
          "Content-Type": "application/json",
          Accept: "application/json",
        };
      }

      const url = `${config.envConfigs[config.env].dxl.url}${
        config["api"]["postpaidProductOrder"]
      }`;

      axios
        .post(url, postOrder, {
          headers: headers,
        })
        .then((response) => {
          if (response.data && response.data.productOrders[0]) {
            setCookieConsentWrapper(
              `cookie_${config.order_id}`,
              [config.cookie_category.strictly_necessary],
              `document.cookie='${config.order_id}=${response.data.productOrders[0].productOrderId};path=/'`
            );
            Cookie.remove("cart_id");

            hideSpinner();
            navigate("orderConfirmation");
          } else {
            hideSpinner();
            handleApiFailure();
          }
        })
        .catch((err) => {
          hideSpinner();
          checkOrderCreation(err);
          handleApiFailure();
        });
    };

    function checkOrderCreation(result) {
      if (result.messages) {
        let len = result.messages.length;
        for (let i = 0; i < len; i++) {
          if (
            result.messages[i].key == "orderStatus" &&
            getOrderCreated(result.messages[i].message)
          ) {
            Cookie.remove("cart_id");
          }
        }
      }
    }

    function handleApiFailure() {
      const pageName = `checkout: credit check: ${customerStatus}`;
      setPageErr({
        type: "error",
        title: labels.checkout.lbl_technical_error_title,
        desc: labels.checkout.lbl_technical_error_desc,
        primaryLabel: null,
        secondaryLabel: "Exit checkout",
        handlePrimaryClick: () => handlePrimaryClick(null, "exit checkout"),
        imgUrl: `${imagePrefix}/assets/images/error-warning-red.svg`,
        pageName: pageName,
        pageErrorType: "technical error",
      });
      navigate("pageError");
    }

    const handlePrimaryClick = (url, label) => {
      showSpinner();
      const pageName = Analytics.getUtagData(["page_name"]).page_name;
      Analytics.link({
        link_type: "o",
        link_name: `${pageName}: ${label}`,
        page_name: `${pageName}`,
      });

      if (url) {
        router.push(`${urlPrefix}${url}`).then(() => {
          hideSpinner();
        });
      } else {
        router.push(`${urlPrefix}/cart`).then(() => {
          hideSpinner();
        });
      }
    };

    const placeOrder = async () => {
      try {
        showSpinner();
        let shippingMethodData = await setShippingMethodsOnCartService(
          cartId,
          carrierCode,
          methodCode
        );
        if (!shippingMethodData.fail) {
          // TODO add parameter
          let paymentMethodData = await setPaymentMethod(
            cartId,
            totalZero,
            paymentMethodCode
          );
          if (!paymentMethodData.fail) {
            orderRouter();
          } else {
            hideSpinner();
            handleApiFailure();
          }
        } else {
          hideSpinner();
          handleApiFailure();
        }
      } catch {
        hideSpinner();
        handleApiFailure();
      }
    };

    useEffect(() => {
      //display credit vetting outcome page if user clicks on back button on review page
      if (creditVettingDetails) {
        setCreditOutcome({
          visible: true,
          title: creditVettingDetails?.resultTitle,
          desc:
            creditVettingDetails.resultText &&
            creditVettingDetails.resultText !== ""
              ? creditVettingDetails.resultText
              : creditVettingDetails.resultHTML,
          screenType: creditVettingDetails?.resultCode,
          iconType: creditVettingDetails?.icon,
        });
        continueDisable(false);
        if (
          (multicartFlag &&
            creditVettingDetails?.resultCode
              .toUpperCase()
              .includes(
                labels.creditVetting.lbl_resultcode_offline.toUpperCase()
              )) ||
          creditVettingDetails?.resultCode
            .toUpperCase()
            .includes(
              labels.creditVetting.lbl_resultcode_offline_unprocessed.toUpperCase()
            )
        ) {
          getOrderSplitMessage(creditVettingDetails?.resultCode);
          setShowOfflineData(true);
        }
        if (
          (multicartFlag &&
            creditVettingDetails?.resultCode
              .toUpperCase()
              .includes(
                labels.creditVetting.lbl_resultcode_pended.toUpperCase()
              )) ||
          creditVettingDetails?.resultCode
            .toUpperCase()
            .includes(
              labels.creditVetting.lbl_resultcode_referred.toUpperCase()
            )
        ) {
          getOrderSplitMessage(creditVettingDetails?.resultCode);
          setShowDocsData(true);
        }
        if (
          multicartFlag &&
          creditVettingDetails?.resultCode
            .toUpperCase()
            .includes(labels.creditVetting.lbl_resultcode_pending.toUpperCase())
        ) {
          setShowDocsData(true);
        }

        setShowOnceOff(true); //redisplay once-off prices in Checkout Order Summary
      }
    }, [creditVettingDetails]);

    const setDoCreditButtonState = (label, value) => {
      setEditFormState((prevState) => ({
        ...prevState,
        [label]: value,
      }));
    };

    const scrollToTargetAdjusted = (elementID) => {
      var element = document.getElementById(elementID);
      const offset = 96;
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth",
      });
    };

    const enableEditContactDetails = (val) => {
      setShowContactDetails(val);
      setTimeout(() => {
        scrollToTargetAdjusted("contact-detail-section");
      }, 50);
    };

    const enableEditEmploymentDetails = (val) => {
      setShowEmploymentDetails(val);
      setTimeout(() => {
        scrollToTargetAdjusted("employee-detail-section");
      }, 50);
    };

    const enableEditHomeDetails = (val) => {
      setShowHomeDetails(val);
      setTimeout(() => {
        scrollToTargetAdjusted("address-detail-section");
      }, 50);
    };

    const enableDebitDetails = (value) => {
      setShowDebitDetails(value);
      setTimeout(() => {
        scrollToTargetAdjusted("debit-detail-section");
      }, 100);
    };

    const enableEditDeliveryDetails = (val) => {
      setShowDeliveryDetails(val);
      setTimeout(() => {
        scrollToTargetAdjusted("delivery-detail-section");
      }, 100);
    };

    const enableConsentDetails = (val) => {
      setConsentDetails(val);
      setTimeout(() => {
        scrollToTargetAdjusted("consent-detail-section");
      }, 100);
    };

    const getOrderSplitMessage = async (resultCode) => {
      let cbuApi = "";
      let isPendedReferred = false;
      let isOffline = false;
      try {
        if (
          resultCode
            .toUpperCase()
            .includes(
              labels.creditVetting.lbl_resultcode_pended.toUpperCase()
            ) ||
          resultCode
            .toUpperCase()
            .includes(
              labels.creditVetting.lbl_resultcode_referred.toUpperCase()
            )
        ) {
          cbuApi = "pendedReferredSplitMessage";
          isPendedReferred = true;
        } else if (
          resultCode
            .toUpperCase()
            .includes(
              labels.creditVetting.lbl_resultcode_offline.toUpperCase()
            ) ||
          resultCode
            .toUpperCase()
            .includes(
              labels.creditVetting.lbl_resultcode_offline_unprocessed.toUpperCase()
            )
        ) {
          cbuApi = "offlineSplitMessage";
          isOffline = true;
        }
        if (cbuApi) {
          const result = await ajaxService.httpGet(
            "drupalBaseUrl",
            "",
            "api",
            cbuApi
          );
          if (result?.sections[0]?.items) {
            if (isPendedReferred) {
              setSubmitDocMessage(
                result?.sections[0]?.items[1]?.description
                  ? result?.sections[0]?.items[1].description
                  : ""
              );
              setOrderSplitMessage(
                `${
                  result?.sections[0]?.items[0]?.title
                    ? "<strong>" +
                      result?.sections[0]?.items[0].title +
                      "</strong><br/>"
                    : ""
                }` + result?.sections[0]?.items[0].description
              );
            } else if (isOffline && result?.sections[1]?.items) {
              setOrderSplitMessage(
                `${
                  result?.sections[1]?.items[0]?.title
                    ? "<strong>" +
                      result?.sections[1]?.items[0].title +
                      "</strong><br/>"
                    : ""
                }` + result?.sections[1]?.items[0].description
              );
            }
          }
        }
      } catch (e) {}
    };

    return (
      <>
        <CustomContainer className={`${styles["checkout-container"]}`}>
          {!getCreditOutcome.visible && (
            <ul className={`${styles["form-wrapper"]}`}>
              {showPersonalDetails &&
                currentJourneyType != journeyType.addLine && (
                  <li className={`${styles["form-body"]}`}>
                    <PersonalDetails
                      customerStatus={customerStatus}
                      onFormSubmit={enableEditContactDetails}
                      profileData={profileData ? profileData : null}
                      doCreditCheckDisable={setDoCreditButtonState}
                    />
                  </li>
                )}
              <CustomContainer id={"contact-detail-section"} />
              {!showContactDetails ? (
                <li
                  className={`${styles["form-heading"]} ${styles["form-body"]}`}
                >
                  <Image
                    img_path={`${imagePrefix}/assets/images/icon-call-disable.svg`}
                    img_alt="section"
                  />
                  Contact details
                </li>
              ) : (
                <li className={`${styles["form-body"]}`}>
                  <ContactDetails
                    customerStatus={customerStatus}
                    onFormSubmit={enableEditEmploymentDetails}
                    profileData={profileData ? profileData : null}
                    currentJourneyType={currentJourneyType}
                    doCreditCheckDisable={setDoCreditButtonState}
                  />
                </li>
              )}
              <CustomContainer id={"employee-detail-section"} />
              {!showEmploymentDetails ? (
                <li
                  className={`${styles["form-heading"]} ${styles["form-body"]}`}
                >
                  <Image
                    img_path={`${imagePrefix}/assets/images/icon-career-disable.svg`}
                    img_alt="section"
                    className={styles["section-icon"]}
                  />
                  {currentJourneyType != journeyType.addLine
                    ? "Work details"
                    : "Salary Details"}
                </li>
              ) : (
                <li className={`${styles["form-body"]}`}>
                  <EmploymentDetails
                    customerStatus={customerStatus}
                    currentJourneyType={currentJourneyType}
                    onFormSubmit={enableEditHomeDetails}
                    doCreditCheckDisable={setDoCreditButtonState}
                  />
                </li>
              )}
              <CustomContainer id={"address-detail-section"} />
              {!showHomeDetails ? (
                <li
                  className={`${styles["form-heading"]} ${styles["form-body"]}`}
                >
                  <Image
                    img_path={`${imagePrefix}/assets/images/icon-home-disable.svg`}
                    img_alt="section"
                    className={styles["section-icon"]}
                  />
                  Home address
                </li>
              ) : (
                <li className={`${styles["form-body"]}`} id={"address-detail"}>
                  <HomeDetails
                    customerStatus={customerStatus}
                    addressTypes={addressTypes}
                    statesTypes={statesTypes}
                    onFormSubmit={
                      currentJourneyType == journeyType.addLine
                        ? updateShowDebitDetails
                        : enableDebitDetails
                    }
                    currentJourneyType={currentJourneyType}
                    doCreditCheckDisable={setDoCreditButtonState}
                  />
                </li>
              )}
              <CustomContainer id={"debit-detail-section"} />
              {currentJourneyType != journeyType.addLine &&
                (!showDebitDetails ? (
                  <li
                    className={`${styles["form-heading"]} ${styles["form-body"]}`}
                  >
                    <Image
                      img_path={`${imagePrefix}/assets/images/icon-bank-disable.svg`}
                      img_alt="section"
                      className={styles["section-icon"]}
                    />
                    Bank account details
                  </li>
                ) : (
                  <li className={`${styles["form-body"]}`}>
                    <DebitDetails
                      customerStatus={customerStatus}
                      setShowSnackBar={setShowSnackBar}
                      setPageErr={setPageErr}
                      navigate={navigate}
                      onFormSubmit={enableEditDeliveryDetails}
                      doCreditCheckDisable={setDoCreditButtonState}
                      multicartFlag={multicartFlag}
                    />
                  </li>
                ))}
              <CustomContainer id={"delivery-detail-section"} />
              {!showDeliveryDetails ? (
                <li
                  className={`${styles["form-heading"]} ${styles["form-body"]}`}
                >
                  <Image
                    img_path={`${imagePrefix}/assets/images/icon-delivery-disable.svg`}
                    img_alt="section"
                    className={styles["section-icon"]}
                  />
                  Delivery details
                </li>
              ) : (
                <li className={`${styles["form-body"]}`}>
                  <DeliveryDetails
                    userLoggedIn={userLoggedIn}
                    profileData={profileData}
                    customerStatus={customerStatus}
                    addressTypes={addressTypes}
                    statesTypes={statesTypes}
                    countryCode={countryCode}
                    countryName={countryName}
                    setShowSnackBar={setShowSnackBar}
                    setPageErr={setPageErr}
                    navigate={navigate}
                    onFormSubmit={enableConsentDetails}
                    carrierCode={carrierCode}
                    methodCode={methodCode}
                    currentJourneyType={currentJourneyType}
                    doCreditCheckDisable={setDoCreditButtonState}
                  />
                </li>
              )}
              <CustomContainer id={"consent-detail-section"} />
              {!showConsentDetails ? (
                <li
                  className={`${styles["form-heading"]} ${styles["form-body"]}`}
                >
                  <Image
                    img_path={`${imagePrefix}/assets/images/consent-disable.svg`}
                    img_alt="section"
                  />
                  Credit check consent
                </li>
              ) : (
                <li className={`${styles["form-body"]}`}>
                  <ConsentResultDetails
                    customerStatus={customerStatus}
                    setShowSnackBar={setShowSnackBar}
                    setPageErr={setPageErr}
                    navigate={navigate}
                    setCreditOutcome={setCreditOutcome}
                    continueDisable={continueDisable}
                    dealCategoryId={dealCategoryId}
                    setShowDocsData={setShowDocsData}
                    setShowOfflineData={setShowOfflineData}
                    currentJourneyType={currentJourneyType}
                    isDoCreditCheckDisable={doCreditCheckDisable}
                    carrierCode={carrierCode}
                    methodCode={methodCode}
                    multicartFlag={multicartFlag}
                    setShowOnceOff={setShowOnceOff}
                  />
                </li>
              )}
            </ul>
          )}
          {getCreditOutcome.visible && (
            <>
              <OutcomeInformation
                className={styles["information"]}
                title={getCreditOutcome.title}
                iconType={getCreditOutcome.iconType}
                description={getCreditOutcome.desc}
                formName="credit-vetting-outcome"
                screenType={getCreditOutcome.screenType}
                customerStatus={customerStatus}
                setDisableBackButton={setDisableBackButton}
                handleHeading={handleHeading}
              />
              {showDocsData && (
                <>
                  <DeliveryTitle
                    contents={[
                      submitDocMessage
                        ? submitDocMessage
                        : labels.creditVetting.lbl_submit_docs_info,
                    ]}
                    className={styles["standard-box"]}
                    id={`checkout-credit-check-status`}
                    iconType="info-white"
                  />
                  {labels.lbl_split_cart_notification_message}
                  {multicartFlag && !submitDocMessage && (
                    <DeliveryTitle
                      contents={[
                        labels.creditVetting
                          .lbl_split_cart_notification_message,
                      ]}
                      className={styles["standard-box"]}
                      id={`checkout-credit-check-status`}
                      iconType="info-white"
                    />
                  )}

                  {multicartFlag && orderSplitMessage && (
                    <DeliveryTitle
                      contents={[orderSplitMessage]}
                      className={styles["standard-box"]}
                      id={`checkout-cart-split-notification`}
                      iconType="info-white"
                    />
                  )}
                </>
              )}
              {showOfflineData && multicartFlag && (
                <DeliveryTitle
                  contents={[
                    orderSplitMessage
                      ? orderSplitMessage
                      : labels.creditVetting
                          .lbl_split_cart_notification_message,
                  ]}
                  className={styles["standard-box"]}
                  id={`checkout-cart-split-notification`}
                  iconType="info-white"
                />
              )}
            </>
          )}
        </CustomContainer>
      </>
    );
  }
);

const mapStateToProps = (state) => {
  return {
    creditCheckDetails: state.creditCheckDetails,
    authDetailsData: state.checkoutDetails.authDetails,
    cartDetails: state.cartDetails,
    creditVettingDetails: state.creditCheckDetails.creditVettingDetails,
    paymentMethodCode: state.checkoutDetails.paymentMethodCode,
  };
};

const mapDispatchToProps = {
  setPostCheckoutCurrentStep,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {
  forwardRef: true,
})(CheckoutCreditCheck);
